import S from '../utils/service'

// 登录
export const login = obj => S.post("user/login", obj);
// 
export const sendIphoneCode = obj => S.post("user/getPhone", obj); //获取手机号
export const sendVerifyCode = obj => S.post("user/sendVerifyCode", obj);// 发送验证码
export const openOrClose = obj => S.post("user/openOrClose", obj);
export const userbackList = obj => S.post("coinConfig/backList", obj); //用户账户
export const userList = obj => S.post("user/listBackUser", obj); //用户列表
export const getUserMenu = obj => S.post("sysRole/getUserMenu", obj); // 菜单列表
export const roleList = obj => S.post("sysRole/list", obj); //角色列表
export const updateRoleIsDel = obj => S.post("sysRole/updateRoleIsDel", obj); //是否可删除角色
export const delRole = obj => S.post("sysRole/batchDelRole", obj); //删除角色
export const addRole = obj => S.post("sysRole/addRole", obj); //添加/修改角色
export const getAllPermission = obj => S.post("sysRole/getAllPermission", obj);// 权限列表
export const addPermission = obj => S.post("sysRole/addPermission", obj); //添加菜单
export const delPermission = obj => S.post("sysRole/batchDelPermission", obj); //删除菜单
export const roleDisPermission = obj => S.post("sysRole/disPermission", obj); //分配权限
export const adminAddUser = obj => S.post("user/adminAddUser", obj); //分配权限
export const delUser = obj => S.post("user/del", obj); // 删除后台账户
export const updateUserPass = obj => S.post("user/updateUserPass", obj); //修改密码

export const nodeList = obj => S.post("minerNode/listPage", obj); // 节点列表
export const saveOrUpdate = obj => S.post("minerNode/saveOrUpdate", obj); // 新增节点
export const updateNode = obj => S.post("minerNode/updateNode", obj); // 编辑
export const nodeALL = obj => S.post("minerNode/list", obj); // 获取所有节点

export const productList = obj => S.post("product/list", obj); // 产品列表
export const productAllAvailable = obj => S.get("product/allAvailable", obj); // 产品列表
export const productAdd = obj => S.post("product/add", obj); // 产品列表
export const areaBlacklistLibrary = obj => S.post("product/areaBlacklistLibrary", obj); // 获取国家


export const coinConfig = obj => S.post("coinConfig/listPage", obj); // 币种列表
export const coinSaveOrUpdate = obj => S.post("coinConfig/saveOrUpdate", obj); // 币种新增/编辑
export const coinQuery = obj => S.post("coinConfig/query", obj); // 币种查询
export const getCoinlistApi = obj => S.post("coinConfig/getCoinlist", obj);//获取所有币种



export const listChargePage = obj => S.post("hashkeyOrders/listChargePage", obj); // 充币记录
export const listPageForAdmin = obj => S.post("hashkeyOrders/listWithdrawPage", obj); // 提币记录
export const audit = obj => S.post("filWithdrawal/audit", obj); // 提币审核

export const channelList = obj => S.post("channel/ListPage", obj); // 渠道列表
export const channelSaveOrUpdate = obj => S.post("channel/saveOrUpdate", obj); // 渠道新增编辑


export const orderList = obj => S.post("product/order/list", obj); // 订单列表
export const orderEarnings = obj => S.post("product/order/earnings ", obj); // 订单收益
export const setNode = obj => S.post("product/order/node", obj); // 分配节点
export const tradeInfo = obj => S.post("product/order/trade/info", obj); // 对冲信息
export const tradeApi = obj => S.post("product/order/trade/api", obj); // 立即对冲
export const checkList = obj => S.post("product/order/check/list", obj); // 录单审核列表
export const personStatus = obj => S.post("product/order/person/status", obj); // 录单审核操作
export const checkUnpaidOrderStatus = obj => S.post("product/order/checkUnpaidOrderStatus", obj); // 录单待支付审核操作
export const userInfo = obj => S.post("product/user/info", obj); // 录单查询用户信息
export const personOrder = obj => S.post("product/person/order", obj); // 录单提交
export const channelInfo = obj => S.get("product/channel/info", obj); // 获取渠道信息
export const productInfo = obj => S.get("product/usable/info", obj); // 获取产品信息
export const orderAdminCheck = obj => S.post("product/order/adminCheck", obj); // 订单审核
export const productPrice = obj => S.post("web/product/price", obj); // 获取产品价格

export const orderTimeline = obj => S.post("product/order/detail/timeline", obj); // 订单月份
export const orderCollectList = obj => S.post("admin/product/order/list", obj); // 订单汇总
export const orderCollectDetail = obj => S.post("product/order/detail", obj); // 订单收益明细

export const pledgeGasPageList = obj => S.get("product/orderRenewal/pledgeGasPageList", obj); // 获取续期质押和Gas分页列表
export const pledgeGas = obj => S.get("product/orderRenewal/pledgeGas", obj); // 获取续期生效的质押和Gas
export const updatePledgeGasAvg = obj => S.post("product/orderRenewal/updatePledgeGasAvg", obj); // 修改续期质押和Gas


// 文案中心
export const articleTypeList = obj => S.post("article/listType", obj);
export const addArticleType = obj => S.post("article/addType", obj);
export const delArticleType = obj => S.post("article/delType", obj);
export const getArticleList = obj => S.post("article/getArticleList", obj);
export const updateArticleFlag = obj => S.post("article/updateArticleFlag", obj);
export const updateArticleExamine = obj => S.post("article/updateArticleExamine", obj);
export const addArticle = obj => S.post("article/addArticle", obj);
export const delArticle = obj => S.post("article/delArticle", obj);
export const getArticle = obj => S.post("article/getArticle", obj);

export const ossImg = obj => S.post("oss/img", obj);//图片上传

export const sysUserAuthList = obj => S.post("sysUserAuth/listPage", obj);//实名认证列表
export const sysUserAudit = obj => S.post("sysUserAuth/audit", obj);//实名审核

export const nodeHistory = obj => S.post("minerNode/history", obj);//节点分币列表
export const updateFil = obj => S.post("minerNode/updateNodeIncome", obj);//分币编辑

export const companyPowerDaily = obj => S.post("companyPowerDaily/page", obj);//公司每日算力汇总
export const nodePowerDaily = obj => S.post("nodePowerDaily/page", obj);//节点产币耗币汇总

export const nodePoolAll = obj => S.get("nodePool/all", obj);//所有矿池
export const nodePoolAllDetail = obj => S.get("nodePool/allDetail", obj);//矿池列表
export const nodePoolAdd = obj => S.post("nodePool/add", obj);//添加矿池
export const nodePoolUpdate = obj => S.post("nodePool/update", obj);//修改矿池
export const nodePoolEnable = obj => S.post("nodePool/enable", obj);//是否开启矿池分币
export const autoAllocate = obj => S.post("nodePool/autoAllocate", obj);//是否开启自动分币


export const nodePoolIncomeRecords = obj => S.post("nodePool/incomeRecords", obj);//矿池收益列表
export const nodeIncomeDetails = obj => S.get("nodePool/nodeIncomeDetails", obj);//矿池节点收益列表
export const nodePoolAllocate = obj => S.post("nodePool/nodePoolAllocate", obj);//矿池节点分币
export const updateNodeIncome = obj => S.post("nodePool/updateNodeIncome", obj);//矿池节点分币编辑


export const netPowerDaily = obj => S.post("netPowerDaily", obj);//全网数据
export const netPowerExport = obj => S.post("netPowerDaily/export", obj);//全网数据导出


export const operatorPageList = obj => S.post("web/operator/operatorPageList", obj);//OP列表
export const addOperator = obj => S.post("web/operator/addOperator", obj);//OP添加
export const deleteOperator = obj => S.post("web/operator/deleteOperator", obj);//OP删除


export const agentPageList = obj => S.post("web/agent/agentPageList", obj);//代理列表
export const addAgent = obj => S.post("web/agent/addAgent", obj);//代理添加
export const deleteAgent = obj => S.post("web/agent/deleteAgent", obj);//代理删除
export const updateAgent = obj => S.post("web/agent/updateAgent", obj);//代理编辑
export const agentOrderList = obj => S.post("web/agent/agentOrderList", obj);//代理订单


export const couponPage = obj => S.post("couponPool/page", obj);//优惠券列表
export const couponAdd = obj => S.post("couponPool/add", obj);//优惠券列表
export const couponUpdate = obj => S.post("couponPool/update", obj);//优惠券列表
export const couponDelete = obj => S.post("couponPool/delete", obj);//优惠券删除
export const couponToCheck = obj => S.post("couponPool/toCheck", obj);//优惠券提交
export const couponDetail = obj => S.post("couponPool/detail", obj);//优惠券详情
export const couponCheck = obj => S.post("couponPool/check", obj);//优惠券同意或拒绝
export const stopOrContinueRelease = obj => S.post("couponPool/stopOrContinueRelease", obj);//优惠券暂停或继续发放

export const nodeProductAccountExport = obj => S.post("nodeProductAccount/export", obj);//节点生产台账

export const agentStatisticsPage = obj => S.post("web/agent/agentStatistics/page", obj);//当前代理统计
// export const nodeProductAccountExport = obj => S.post("web/agent/agentStatistics/export", obj);//当前代理统计导出
export const agentStatisticsHistoryPage = obj => S.post("web/agent/agentStatisticsHistory/page", obj);//历史代理统计
export const auditRecords = obj => S.post("hashkeyOrders/withdrawal/audit/records", obj);//审核明细

export const filBalancePage = obj => S.post("userBalance/balanceHistory/page", obj);//FIL盘点表统计
export const companyIncomeDailyExport = obj => S.post("companyIncomeDaily/page", obj);//自挖矿汇总

export const cooperateListApi = obj => S.get("cooperateInfo/page", obj);//合作申请
export const cooperateDetailApi = obj => S.get("cooperateInfo/info", obj);//合作申请-查看详情

export const withdrawFinanceInfo = obj => S.post("hashkeyOrders/withdrawFinanceInfo", obj);//提币审核查看

export const getUnitIncomeSettings = obj => S.get("sys/config/getUnitIncomeSettings", obj);//查看配置
export const updateUnitIncomeSettings = obj => S.post("sys/config/updateUnitIncomeSettings", obj);//设置配置

export const salesStatisticsDetail = obj => S.post("web/agent/salesStatisticsDetail", obj);//销售台账明细
export const salesStatisticsSummary = obj => S.post("web/agent/salesStatisticsSummary", obj);//销售台账汇总

export const userBalanceChangePageApi = obj => S.post("coinUser/userBalanceChange/page", obj);//用户资金变动记录分页列表
export const userBalanceChangeExportApi = obj => S.post("coinUser/userBalanceChange/export", obj);//导出用户资金变动记录分页列表

export const commonCoinPrice = obj => S.get("coinPrice/commonCoinPrice", obj);//获取汇率

export const pledgeGasDailyList = obj => S.post("coinPrice/pledgeGasDaily/page", obj);//每日Gas质押分页列表
export const pledgeGasConfig = obj => S.get("coinPrice/pledgeGasConfig", obj);//获取Gas质押配置
export const coinPriceApi = obj => S.post("coinPrice/coinPriceDaily/page", obj);//每日价格分页列表
export const coinInfoApi = obj => S.get("coinPrice/getAllCoinInfo", obj);//获取所有币种信息

export const summaryList = obj => S.post("userBalance/availableFilBalance/summary", obj);//获取FIL可用
export const filBalanceSummaryList = obj => S.post("userBalance/pledgeFilBalance/summary", obj);//获取质押FIL汇总
export const filBalanceSummaryDetail = obj => S.post("userBalance/pledgeFilBalance/detail", obj);//获取质押FIL详情
export const frozenFilBalanceList = obj => S.post("userBalance/frozenFilBalance/summary", obj);//获取待释放FIL汇总
export const frozenFilBalanceDetail = obj => S.post("userBalance/frozenFilBalance/detail", obj);//获取待释放FIL详情
export const usdtBalanceList = obj => S.post("userBalance/usdtBalance/summary", obj);//获取可用USDT明细
export const updateUsdtBalance = obj => S.post("userBalance/updateUsdtBalanceSummary", obj);//修改可用USDT明细的kucoin
export const filSummary = obj => S.post("userBalance/filBalance/summary", obj);//FIL汇总














